import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  scrollTo(event) {
    event.preventDefault()
    const url = event.currentTarget.dataset.url
    const element = document.querySelector(url)

    if (element) {
      const header = document.querySelector("header") || document.querySelector(".panel-title.ui.sticky")
      const offset = header ? header.offsetHeight : 0
      const elementPosition = element.getBoundingClientRect().top + window.scrollY - offset

      window.scrollTo({
        top: Math.max(0, elementPosition - 20),
        behavior: "smooth"
      })
    }
  }
}

